import { render, staticRenderFns } from "./BoletosFerry.vue?vue&type=template&id=4c443442&"
import script from "./BoletosFerry.vue?vue&type=script&lang=js&"
export * from "./BoletosFerry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports